// extracted by mini-css-extract-plugin
module.exports = {"text":"Y_jEwerWBRSgIUor","button":"_2zFdb-z__O5nQ7OA","title":"_3mcmrJgD2XEPvHoZ","actions":"_1bPZlQhOwaOzqyFH","xsButton":"_39_YabriRegUqfqg","subHeading":"CaG2PpblhymtfDGz"};